import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OnboardingService {
    baseURL = environment.repoUrl;

    // Private
    private _order: BehaviorSubject<any | null> = new BehaviorSubject(null);
    private _onboarding: BehaviorSubject<any | null> = new BehaviorSubject(
        null,
    );

    //     Onboarding state (new)
    // - GET  /api/webshop/onboarding returns the current user's flags:
    // { caregiver, contacts, insurance, wlanConfiguration, emergencyCallSettings, commitments
    // }. Authenticated (user's own row).
    // - PATCH /api/webshop/onboarding updates any subset of the flags. Send only what you want to change, e.g. { "caregiver": true }.
    // Returns the full updated
    // object.

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    /**
     * Getter for order
     */
    get order$(): Observable<any> {
        return this._order.asObservable();
    }

    get onboarding$(): Observable<any> {
        return this._onboarding.asObservable();
    }

    getOrder() {
        return this._httpClient.get(`${this.baseURL}/api/webshop/order`).pipe(
            tap((order) => {
                this._order.next(order);
            }),
        );
    }

    getOnboarding() {
        return this._httpClient
            .get(`${this.baseURL}/api/webshop/onboarding`)
            .pipe(
                tap((onboarding) => {
                    this._onboarding.next(onboarding);
                }),
            );
    }

    updateOnboarding(params: any) {
        return this._httpClient.patch(
            `${this.baseURL}/api/webshop/onboarding`,
            params,
        );
    }
}
